import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

const props = withCompInfo<any, any>()(['compData'], ({ compData }) => {
  return {
    ...{ tooltipInfo: '', options: [], fieldTitle: 'Multiple Choices' },
    ...compData,
  };
});

export default createComponentMapperModel({
  props,
});
